import React, { useEffect, useState } from "react";
import { PageHeader } from "components/ui";
import { Grid, Box } from "@mui/material";

import GriFormComponent from "components/customizedStandardsComponent/GriFormComponent";
import FreeTextInputComponent from "components/customizedStandardsComponent/FreeTextInputComponent";
import UploadEvidenceComponent from "components/customizedStandardsComponent/UploadEvidenceComponent";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import DownloadPostReviewGapForm from "components/customizedStandardsComponent/DownloadPostReviewGapForm";
import UploadPostReviewGapForm from "components/customizedStandardsComponent/UploadPostReviewGapForm";
import DownloadPostReviewReports from "components/customizedStandardsComponent/DownloadPostReviewReports";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import NavigationButtons from "helper/navigation/NavigationButtons";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";
import UploadEvidenceReviewReports from "components/customizedStandardsComponent/UploadEvidenceReviewReports";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";

import {
  RELATIVE_COMMUNITY_SENSITIVITY_FORM,
  GENDER_IMPACT_ASSESSMENT_FORM,
  STAKEHOLDER_ENGAGEMENT_SUMMARY_FORM,
  LIVELIHOOD_IMPACT_ASSESSMENT_FORM,
  WORKER_WELFARE_AUDIT_FORM,
  GRIEVANCE_MANAGEMENT_REPORTING_FORM,
} from "data/forms/griFormSchema";

import {
  CLIMATE_IMPACT_STANDARDS,
  ENVIROMENTAL_COMPLIANCE_REPORTING,
} from "data/standards/griStandards";

import { FREE_TEXT_SOCIAL } from "data/prompts/freeTextPrompts";

import {
  esLegalApplicationReq,
  esLegalApplicationScopeCompParams,
  esLegalApplicationScopeCompActivity,
  esLegalApplicationScopeCompLogs,
  esLegalApplicationScopeComptracking,
  esLegalApplicationScopeComptrackingCheck,
} from "data/reports/relevantReports";

const ESLegalApplicationReq = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });
  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(0);

  const steps = [
    "Download Social Compliance Reporting",
    "Download Scope and Compliance Parameters",
    "Download Scope and Compliance Activities",
    "Download Scope and Compliance Logs",
    "Download Scope and Compliance Tracking",
    "Download Scope and Compliance Tracking Checklist & Alerts",
  ];

  const handleNext = () => {
    if (activeStep < 5) {
      setActiveStep((prev) => prev + 1);
    } else {
      console.log("Reached end of stepper");
    }
  };

  // useEffect(() => {
  //     if (activeStep === 6 && prevStep === 5) {
  //         setShowReviewPopup(true);
  //     }
  //     setForceUpdate(prev => prev + 1);
  // }, [activeStep, prevStep]);

  const handleBack = () => {
    setPrevStep(activeStep);
    setActiveStep((prev) => prev - 1);
  };

  const handleSaveStandards = (selectedStandards) => {
    setReportData((prev) => ({
      ...prev,
      selectedStandards,
    }));
  };

  const handleClosePopup = () => {
    setShowReviewPopup(false);
  };

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(7);
    setShowReviewPopup(false);
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <DownloadReport
            key="social-compliance-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esLegalApplicationReq}
            description="Download and review social compliance guidelines and frameworks"
            stepId="step-0"
            title="E&S Legal and Applicable Requirements "
            ReportDownloadButtonShow={false}
          />
        );
      case 1:
        return (
          <DownloadReport
            key="scope-compliance-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esLegalApplicationScopeCompParams}
            description="Download and review social compliance guidelines and frameworks"
            stepId="step-0"
            title="E&S Legal and Applicable Requirements"
            ReportDownloadButtonShow={false}
          />
        );
      case 2:
        return (
          <DownloadReport
            key="scope-compliance-activities-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esLegalApplicationScopeCompActivity}
            description="Download and review social compliance guidelines and frameworks"
            stepId="step-0"
            title="E&S Legal and Applicable Requirements"
            ReportDownloadButtonShow={false}
          />
        );

      case 3:
        return (
          <DownloadReport
            key="legal-compliance-logs-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esLegalApplicationScopeCompLogs}
            description="Download and review social compliance guidelines and frameworks"
            stepId="step-0"
            title="Download Legal Compliance Log"
          />
        );

      case 4:
        return (
          <DownloadReport
            key="legal-compliance-tracking-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esLegalApplicationScopeComptracking}
            description="Download and review social compliance guidelines and frameworks"
            stepId="step-0"
            title="Legal Compliance Tracking"
            ReportDownloadButtonShow={false}
          />
        );

      case 5:
        return (
          <DownloadReport
            key="legal-compliance-tracking-checklist-alert"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esLegalApplicationScopeComptrackingCheck}
            description="Download and review social compliance guidelines and frameworks"
            stepId="step-0"
            title="Compliance Tracking Checklist & Gap Analysis and Alerts"
            NextButtonShow={false}
            showReportCountdownButton={true}
          />
        );

      default:
        return <div>Unknown step</div>;
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <NavigationButtons
              imageKey="dashboardImg3_6"
              title="E&S Legal & Applicable Requirements"
              activeStep={activeStep}
              onBack={handleBack}
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          {getStepContent(activeStep)}
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
              mb: 2,
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToStep5}
      />
    </>
  );
};

export default ESLegalApplicationReq;
